module.exports = __webpack_public_path__ + "static/media/No_Host_Property_Banned.56a4ad87.png";